<rpe-terminos-condiciones></rpe-terminos-condiciones>
<div class="button">
    <button mat-raised-button (click)="onCancel()" color="primary">
        Cerrar
    </button>
</div>
